export default __webpack_public_path__ + "static/media/furgonetka-light.7dc2f3f4.svg";